import { CurrentAddressActions, PermanentAddressActions } from "./action";

const initialState = {
  Current: [],
  per: []

}


const TeamDetailsReducer = (state = initialState, action) => {

  switch (action.type) {


    case CurrentAddressActions.CURRENT_ADDRESS_SUCCESS:
      return {
        ...state,
        Current: action.payload
      };

    case PermanentAddressActions.PERMANENT_ADDRESS_SUCCESS:
      return {
        ...state,
        per: action.payload
      };
    default:
      return state;
  }

}




export default TeamDetailsReducer